module.exports = function ($compile, moveFocus) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            // loading variable
            loading: '=?',
            spinnerClass: '@?',
            buttonClass: '@?',
            childSpinnerClass: '@?',
            spinnerButtonClass: '@?',
        },
        compile(tElem) {
            let loading = tElem.find('._oly-button-loading');

            return {
                post(scope, element, iAttrs, controller, transcludeFn) {
                    transcludeFn((clone) => {
                        element.find('._oly-button-transclude').html($compile(clone)(scope));
                    });

                    loading = element.find('._oly-button-loading');

                    // check if there is a link with an href
                    let button = element.find('[href]');

                    if (!button || button.length <= 0) {
                        // if there is no element with [href], we look for an element with button class
                        button = element.find('.button');
                    }

                    scope.btnClass = button.attr('class');

                    // default loading state
                    if (!scope.loading) {
                        scope.loading = {
                            state: false,
                            message: 'loading, please wait',
                        };
                    } else {
                        scope.$watch(() => scope.loading, (newVal, oldVal) => {
                            if (newVal.state && !oldVal.state) {
                                moveFocus(loading);
                            }
                        });
                    }
                },
            };
        },
        template: require('./button.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/common/button/button.directive.js